module.exports = __webpack_public_path__ + "assets/0d045e0cb0f66cad96a931f6c5743973.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/images/bg_pattern.png
 ** module id = 6
 ** module chunks = 0
 **/